document.addEventListener("DOMContentLoaded", function () {

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const section = entry.target;
          observer.unobserve(section);

          const blocksSection = section.querySelector(".stat-blocks");
          if (!blocksSection) {
            return;
          }

          section.querySelectorAll(".stat-block.stat-block-animate").forEach(statBlock => {
            statDonut.resetAndAnimate(statBlock);
          });

          if (blocksSection.classList.contains("stat-blocks-flickity")) {
            const flkty = new Flickity(blocksSection, {
              cellAlign: "center",
              contain: true,
              wrapAround: true,
              autoPlay: false,
              prevNextButtons: true,
              pageDots: false,
              draggable: true,
              watchCSS: true,
              dragThreshold: 10,
            });

            flkty.on("change", function (index) {
              const activeSlide = section.querySelectorAll(".stat-block")[index];
              if (activeSlide && activeSlide.classList.contains("stat-block-animate")) {
                statDonut.resetAndAnimate(activeSlide);
              }
            });
          }
        }
      });
    },
    { threshold: 0.2 }
  );

  document.querySelectorAll(".stat-donut-section").forEach(section => {
    observer.observe(section);
  });
});

// ** Donut Animation Logic**
const statDonut = {
  /**
   * @param {Element} element 
   */
  resetAndAnimate: function (element) {
    if (!element) {
      console.warn("resetAndAnimate: No element found.");
      return;
    }

    if (!element.classList.contains("stat-block-animate")) {
      return;
    }

    const percentage = parseInt(element.dataset.percentage, 10) || 0;

    element.style.setProperty("--donut-percentage", "0");
    element.style.setProperty("--donut-text-percentage", '"0"');

    this.animateDonut(this.animationEaseTiming, (progress) => {
      element.style.setProperty("--donut-percentage", percentage * progress);
      element.style.setProperty(
        "--donut-text-percentage",
        `"${Math.round(percentage * progress)}"`
      );
    }, 1500);
  },

  /**
   * @param {function(number): number} timing 
   * @param {function(number)} draw 
   * @param {number} duration 
   */
  animateDonut: function (timing, draw, duration) {
    let start;

    function step(time) {
      if (!start) {
        start = time;
      }
      let progress;
      let timeFraction = (time - start) / duration;
      if (timeFraction >= 1) {
        timeFraction = 1;
        progress = 1;
      } else {
        progress = timing(timeFraction);
      }

      draw(progress);

      if (timeFraction < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  },

  /**
   * Returns the part of the sine function that goes from the lowest point to highest point
   * @param {number} timeFraction 
   * @returns number
   */
  animationEaseTiming: (timeFraction) =>
    +((Math.sin((timeFraction - 0.5) * Math.PI) + 1) / 2).toFixed(3),
};